import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onFilterOpenButtonClick", "schema", "value", "types", "defaultValue", "onValueChange", "initialValue", "filterOpen", "resultCount", "resultTotalCount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useMemo } from 'react';
import cloneDeep from 'clone-deep';
import { extractDataAttribute, useControlledState, useFlagState, useRootRef } from '../../../../system';
import { getValueRenderFunction } from '../utils/getValueRenderFunction';
import { isConditionValueEmpty as _isConditionValueEmpty } from '../utils/isConditionValueEmpty';
import { FILTER_EMPTY, SCHEMA_EMPTY } from '../../constants';
import { useTypeIndex } from '../../hooks/useTypeIndex';
import { getConditionType } from '../../utils/getConditionType';
export var useFilterViewer = function useFilterViewer(_ref, ref) {
  var onFilterOpenButtonClick = _ref.onFilterOpenButtonClick,
      schema = _ref.schema,
      value = _ref.value,
      types = _ref.types,
      defaultValue = _ref.defaultValue,
      onValueChange = _ref.onValueChange,
      initialValue = _ref.initialValue,
      filterOpen = _ref.filterOpen,
      resultCount = _ref.resultCount,
      resultTotalCount = _ref.resultTotalCount,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var innerRef = useRootRef(ref);

  var _useControlledState = useControlledState(defaultValue, value, onValueChange),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      realValue = _useControlledState2[0],
      setRealValue = _useControlledState2[1];

  var _useFlagState = useFlagState(false),
      _useFlagState2 = _slicedToArray(_useFlagState, 4),
      dialogOpen = _useFlagState2[0],
      setDialogOpen = _useFlagState2[1],
      setDialogOpenTrue = _useFlagState2[2],
      setDialogCloseFalse = _useFlagState2[3];

  var onClearFilterConfirmButtonClick = useCallback(function () {
    setDialogCloseFalse();
    setRealValue(initialValue ? cloneDeep(initialValue) : FILTER_EMPTY);
  }, [setDialogOpenTrue, setRealValue, initialValue]);
  var typeIndex = useTypeIndex(types);
  var rootConditionsCount = useMemo(function () {
    var count = 0;

    if (schema && schema.conditions) {
      schema.conditions.forEach(function (condition) {
        var conditionType = getConditionType(condition, typeIndex);

        if (conditionType && !_isConditionValueEmpty(condition, conditionType, condition.name || condition.id, realValue)) {
          count += 1;
        }
      });
    }

    return count;
  }, [schema, realValue, typeIndex]);
  var onCloseTagButtonClick = useCallback(function (event) {
    var path = extractDataAttribute(event, 'path');

    var newValue = _objectSpread({}, realValue);

    if (newValue.conditions) {
      newValue.conditions = newValue.conditions.filter(function (condition) {
        return condition.name !== path;
      });
    }

    setRealValue(newValue);
  }, [realValue, setRealValue]);
  var schemaSafe = schema && schema.conditions ? schema : SCHEMA_EMPTY;
  var realValueSafe = realValue && realValue.conditions ? realValue : FILTER_EMPTY;
  var empty = !rootConditionsCount;
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      ref: innerRef
    }),
    getOpenFilterButtonProps: function getOpenFilterButtonProps() {
      return {
        onClick: onFilterOpenButtonClick
      };
    },
    getEditFilterButtonProps: function getEditFilterButtonProps() {
      return {
        onClick: onFilterOpenButtonClick
      };
    },
    clearFilterButtonProps: {
      onClick: setDialogOpenTrue
    },
    confirmationDialogProps: {
      open: dialogOpen,
      onOpenChange: function onOpenChange(newValue) {
        return setDialogOpen(newValue);
      }
    },
    clearFilterCancelButtonProps: {
      onClick: setDialogCloseFalse
    },
    clearFilterConfirmButtonProps: {
      onClick: onClearFilterConfirmButtonClick
    },
    rootConditionsCount: rootConditionsCount,
    showAddFilterButton: filterOpen ? false : empty,
    showAddFilterHint: !filterOpen ? false : empty,
    showSelectedFilter: !empty,
    showResultCount: resultCount !== undefined,
    showResultTotalCount: resultTotalCount !== undefined,
    resultCountFormatted: resultCount !== undefined ? new Intl.NumberFormat().format(resultCount) : 0,
    resultTotalCountFormatted: resultTotalCount !== undefined ? new Intl.NumberFormat().format(resultTotalCount) : 0,
    schema: schemaSafe,
    isConditionValueEmpty: function isConditionValueEmpty(condition, path) {
      var conditionType = getConditionType(condition, typeIndex);

      if (!conditionType) {
        return true;
      }

      return _isConditionValueEmpty(condition, conditionType, path, realValueSafe);
    },
    getTagProps: function getTagProps(condition, path) {
      var conditionTypeId = condition.typeId || 'string';
      var conditionType = typeIndex[conditionTypeId];
      var conditionValue = realValueSafe.conditions.find(function (conditionValueItem) {
        return conditionValueItem.name === path;
      });
      var renderValue = getValueRenderFunction(getConditionType(condition, typeIndex));
      var tagValue = renderValue(condition, conditionType, conditionValue);
      return {
        label: condition.label || condition.name,
        value: tagValue,
        onCloseButtonClick: onCloseTagButtonClick,
        path: path
      };
    }
  };
};